<template>
  <main class="getting-started">
    <div class="content">
      <header>
        <!-- <h1 class="title">
            <span>Getting</span>
            <span>Started</span>
        </h1> -->
        <img src="@/assets/rebrand/gettingstarted/title.png" alt="title" class="img-title" />
        <img
          src="@/assets/rebrand/gettingstarted/gs-shape.png"
          alt="getting started shape"
          class="img-gs-shape"
        />
        <!-- <header> -->
        <nav class="navbar-tab">
          <ul>
            <li v-for="(tab, tabName) in tabs" :key="tabName">
              <button
                class="tab"
                @click="setTabActive(tabName)"
                :class="{ active: tabName === activeTab }"
              >
                <span class="tab-copy" v-html="tabName"></span>
                <div class="bg-active" />
                <!-- <span class="tab-background">
                <span class="tab-rounding left"></span>
                <span class="tab-rounding right"></span>
              </span> -->
              </button>
            </li>
          </ul>
        </nav>
      </header>
      <!-- </header> -->
      <article>
        <div class="container">
          <transition name="fade" mode="out-in" appear :duration="500">
            <tab-content
              v-for="(tabContent, t) in tabs"
              :data="tabContent"
              :key="'content' + t"
              v-if="t === activeTab"
              inline-template
            >
              <div :class="'content-' + data.id">
                <h1 v-html="data.title" class="title"></h1>
                <p v-html="data.body" class="body"></p>
                <img :src="data.img" :alt="data.title" class="illustration" />
                <img :src="data.imgGrid" :alt="data.title" class="grid -mb" />
                <b-button class="btn-join-now" :href="data.btnLink" target="_blank">
                    <img :src="data.imgbtn" :alt="data.title" />
                </b-button>
              </div>
            </tab-content>
          </transition>

          <ul class="tab-ul">
            <li v-for="(tab, tabName) in tabs" :key="tabName">
              <button
                class="tab"
                @click="setTabActive(tabName)"
                :class="{ active: tabName === activeTab }"
              >
                <!-- <span class="tab-copy" v-html="tabName"></span>
                <div class="bg-active" /> -->
                <!-- <span class="tab-background">
                <span class="tab-rounding left"></span>
                <span class="tab-rounding right"></span>
              </span> -->
              </button>
            </li>
          </ul>
        </div>
      </article>
    </div>
  </main>
</template>
<script>
export default {
  name: 'GettingStarted',
  data() {
    return {
      activeTab: 'Join our Discord<br/> Group',
      tabs: {
        'Join our Discord<br/> Group': {
          id: 0,
          title: 'JOIN OUR DISCORD<br/>FOR UPDATES AND ALLOWLIST ',
          body:
            "Congratulations, you made it! Join a free-flowing <br/>conversation around the latest in web3, NFT's, <br/>sneakers, and streetwear. Tap in quickly to get early <br/>access to Community Allowlist privileges and inside <br/>info on what's happening in the HUD. All are welcome. ",
          img: require('../assets/rebrand/gettingstarted/illus-join-teleg.png'),
          imgbtn: require('../assets/rebrand/home/join now new discord.png'),
          imgGrid: require('../assets/mobile/getting-started-grid-mob.png'),
          btnLink: 'https://discord.gg/snkrhud',
        },
        'Get Allowlist <br/> Access': {
          id: 1,
          title: 'GET ALLOWLIST <br/>ACCESS ',
          body:
            "We've partnered with the top Flow NFT projects as <br/>well as some of your favorite sneaker platforms and  <br/>influencers to provide you guaranteed access to a <br/>coveted Side Kick during Pre Sale. All alpha provided <br/>through our Discord and Twitter accounts first!",
          img: require('../assets/rebrand/gettingstarted/illus-create-connect.png'),
          imgbtn: require('../assets/rebrand/gettingstarted/join-now.png'),
          imgGrid: require('../assets/mobile/getting-started-grid-mob.png'),
          btnLink: 'https://discord.gg/snkrhud',
        },
        'Mint Your<br/>Side Kick': {
          id: 2,
          title: 'MINT YOUR SIDE KICK',
          body:
            "Side Kicks will be minting exclusively through Gaia<br/> [home of Ballerz]. You will first need to set up your<br/> Dapper Wallet, which allows you the ability to  <br/>purchase with a Credit Card. New to Crypto?<br/> No problem! We've worked hard to provide you the <br/>best onboarding experience, whether you're new to <br/>web3 or having a growing collection of NFT's. ",
          img: require('../assets/rebrand/gettingstarted/illus-mint.png'),
          imgbtn: require('../assets/rebrand/home/mint-now-gaia.png'),
          imgGrid: require('../assets/mobile/getting-started-grid-mob.png'),
          btnLink: 'https://ongaia.com/snkrhud',
        },
        'Share Your <br/>Side Kick': {
          id: 3,
          title: 'SHARE YOUR SIDE KICK ON <br/>OTHER SOCIAL PLATFORMS',
          body:
            "Show off your hand drawn retro-future art on all social <br/>platforms. Shout out the dopest pieces of sneaker-inspired <br/>armor and accessories on your Side Kick. Flex the rarest <br/>traits or even just the pieces that mean the most to you. <br/>Let's let both the NFT and Sneaker communities know that <br/>SNKRHUD is the only metaverse that matters. ",
          img: require('../assets/rebrand/gettingstarted/illus-side-kick.png'),
          imgbtn: require('../assets/rebrand/gettingstarted/join-now.png'),
          imgGrid: require('../assets/mobile/getting-started-grid-mob.png'),
          btnLink: 'https://discord.gg/snkrhud',
        },
        'Download<br/>SnkrHUD App': {
          id: 4,
          title: 'DOWNLOAD APP & START <br/>BUILDING VOUR SNEAKER LEGACY',
          body:
            "Connect your Dapper Wallet to the SNKRHUD app to begin<br/> exploring a Lookbook of the rarest Side Kick heroes, including<br/> your own. Soon you'll be able to utilize additional tools, like <br/>the DED Stock Creator to design and share your own sneaker<br/> moment as NFT's that you can buy and sell. These assets will <br/>eventually unlock PVE and PVP Sneaker Battles earning you<br/> $CRED. Our platform is designed to allow you to interact with <br/> and monetize your sneaker collection in an entirely new way. ",
          img: require('../assets/rebrand/gettingstarted/illus-download.png'),
          imgbtn: require('../assets/rebrand/gettingstarted/join-now.png'),
          imgGrid: require('../assets/mobile/getting-started-grid-mob.png'),
          btnLink: 'https://discord.gg/snkrhud',
        },
      },
    };
  },
  computed: {
    tabContent() {
      return this.tabs[this.activeTab];
    },
  },
  methods: {
    setTabActive(tab) {
      this.activeTab = tab;
    },
  },
  components: {
    TabContent: {
      props: {
        data: Object,
      },
    },
  },
};
</script>
<style lang="scss">
@import "../assets/styles/fontstyle.css";
@import "../assets/styles/gettingstarted.scss";
</style>
